import React from "react";
import { Tabs } from "antd";

import BarChart from "./BarChart";

const TagsAnalysis = () => {
  const items = [
    {
      key: "1",
      label: "用户分层",
      children: (
        <BarChart
          title="用户分层"
          data={[
            ["用户标签", "2022", "2023", "2024", "2025"],
            ["普通用户", 1244, 1789, 2165, 2899],
            ["车主用户", 1667, 1788, 1898, 2888],
            ["官方账号", 233, 445, 666, 888],
            ["KOL达人", 123, 233, 333, 456],
          ]}
        />
      ),
    },
    {
      key: "2",
      label: "车型解析",
      children: (
        <BarChart
          title="车型解析"
          data={[
            ["车型标签", "2022", "2023", "2024", "2025"],
            ["山海系列", 22, 122, 177, 488],
            ["大圣系列", 86.5, 92.1, 85.7, 83.1],
            ["旅行者系列", 24.1, 67.2, 79.5, 86.4],
          ]}
        />
      ),
    },
    {
      key: "3",
      label: "内容场景",
      children: (
        <BarChart
          title="内容场景"
          data={[
            ["场景标签", "2022", "2023", "2024", "2025"],
            ["旅行者分享", 41.1, 30.4, 65.1, 53.3],
            ["使用攻略", 86.5, 92.1, 85.7, 83.1],
            ["活动分享", 24.1, 67.2, 79.5, 86.4],
            ["爱车养车", 24.1, 67.2, 79.5, 86.4],
          ]}
        />
      ),
    },
  ];

  return (
    <div style={{ padding: "20px", width: "100%", overflow: "scroll" }}>
      <Tabs defaultActiveKey="1" items={items} />
    </div>
  );
};

export default TagsAnalysis;
